export enum PositionType {
    Top = 1,
    Bottom,
}